(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9738],{

/***/ 93615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Set click outside menu by customized hook.
 * @param {reference} ref connect jsx reference.
 * @param {function} handler set the new state to close the menu.
 */

var useOnClickOutside = function useOnClickOutside(ref, handler) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var listener = function listener(event) {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(false);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return function () {
      /* Clean up function. Remove event before component unmount. */
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useOnClickOutside);

/***/ }),

/***/ 46518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dK": function() { return /* binding */ EXCHANGE; },
/* harmony export */   "ZP": function() { return /* binding */ priceConvert; },
/* harmony export */   "DJ": function() { return /* binding */ LocalStorageAutoConvertPrice; },
/* harmony export */   "Nd": function() { return /* binding */ AutoConvertPriceWithUnit; },
/* harmony export */   "eY": function() { return /* binding */ convertPriceOnString; }
/* harmony export */ });
/* unused harmony exports isEqualString, LocalStorageAutoConvertUnit */
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51423);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40037);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var common_source_function_numberFormat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80077);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72713);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable



var exchangeData = [{
  id: 1,
  name: "bbcincorp.com",
  currency_id: 3,
  min_amount: 1,
  min_unit: 10,
  Currency: {
    id: 3,
    name: "Hong Kong dollar",
    code: "HKD",
    symbol: "$",
    exchange_rate: 7.86,
    is_deleted: false
  }
}, {
  id: 2,
  name: "bbcincorp.sg",
  currency_id: 6,
  min_amount: 1,
  min_unit: 10,
  Currency: {
    id: 6,
    name: "Singapore dollar",
    code: "SGD",
    symbol: "$",
    exchange_rate: 1.33,
    is_deleted: false
  }
}];
var EXCHANGE = [{
  id: 1,
  name: "USD",
  value: "US$"
}, {
  id: 6,
  name: "SGD",
  value: "SG$"
}];
var EXCHANGE_RATE = [{
  from: 1,
  to: 6,
  rate: 1.33
}];
var DEFAULT_UNIT = EXCHANGE[0].id;
function isEqualString(a, b) {
  return parseInt(a, 10) === parseInt(b, 10);
}
/** Find Unit From Exchange
 * const findUnitFromExchange = (unitId) => {
  return EXCHANGE_RATE.find((item) => item.id === unitId);
};
 */

var findUnitFromRate = function findUnitFromRate(from, to) {
  // return EXCHANGE_RATE.find((item) => {
  //   const exchangeSumId = parseInt(item.from, 10) + parseInt(item.to, 10);
  //   const paramSumId = parseInt(from, 10) + parseInt(to, 10);
  //   return exchangeSumId === paramSumId;
  // });
  var findCurrency = exchangeData.find(function (item) {
    var exchangeSumId = DEFAULT_UNIT + parseInt(item.currency_id, 10);
    var paramSumId = parseInt(from, 10) + parseInt(to, 10);
    return exchangeSumId === paramSumId;
  });
  return {
    from: from,
    to: to,
    min_unit: findCurrency.min_unit,
    min_amount: findCurrency.min_amount,
    rate: findCurrency === null || findCurrency === void 0 ? void 0 : findCurrency.Currency.exchange_rate
  };
};

var exchangeCalculator = function exchangeCalculator(amount, ratio, min_unit, min_amount) {
  var amountEx = Math.abs(amount) * ratio;
  amountEx = (Math.floor(amountEx / min_unit) + Math.round(amountEx % min_unit / min_unit)) * min_unit;
  if (amountEx < min_amount) amountEx = min_amount; // Service zero fee

  if (amount == 0) amountEx = 0;

  if (amount < 0) {
    amountEx *= amountEx * -1;
  }

  return amountEx;
};

function priceConvert(_ref) {
  var from = _ref.from,
      to = _ref.to,
      price = _ref.price;
  var FILTER_RATE = findUnitFromRate(from, to);

  if (isEqualString(FILTER_RATE === null || FILTER_RATE === void 0 ? void 0 : FILTER_RATE.from, from)) {
    // Return Math.round(price * FILTER_RATE.rate);
    return exchangeCalculator(price, FILTER_RATE.rate, FILTER_RATE.min_unit, FILTER_RATE.min_amount);
  }

  if (isEqualString(FILTER_RATE === null || FILTER_RATE === void 0 ? void 0 : FILTER_RATE.from, to)) {
    // Return Math.round(price / FILTER_RATE.rate);
    return price;
  }
}
function LocalStorageAutoConvertUnit(unit) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts__WEBPACK_IMPORTED_MODULE_2__/* .LayoutContext */ .VY),
      currencyUnit = _useContext.currencyUnit;

  if ( false || unit && isEqualString(unit, currencyUnit.id)) {
    return currencyUnit.value;
  }

  var PRICE_UNIT = JSON.parse(window.localStorage.getItem("price_unit"));

  if (PRICE_UNIT !== null && PRICE_UNIT !== void 0 && PRICE_UNIT.previous) {
    return PRICE_UNIT.value;
  }

  return currencyUnit.value;
}
function LocalStorageAutoConvertPrice(price, initialUnit) {
  var _useContext2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts__WEBPACK_IMPORTED_MODULE_2__/* .LayoutContext */ .VY),
      currencyUnit = _useContext2.currencyUnit;

  if ( false || isEqualString(initialUnit, currencyUnit.id)) {
    return (0,common_source_function_numberFormat__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(price);
  }

  var PRICE_UNIT = JSON.parse(window.localStorage.getItem("price_unit"));

  if (PRICE_UNIT !== null && PRICE_UNIT !== void 0 && PRICE_UNIT.previous) {
    return (0,common_source_function_numberFormat__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(priceConvert({
      from: PRICE_UNIT.previous,
      to: PRICE_UNIT.current,
      price: price
    }));
  }

  return (0,common_source_function_numberFormat__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(priceConvert({
    from: initialUnit,
    to: DEFAULT_UNIT,
    price: price
  }));
}
function AutoConvertPriceWithUnit(price, initialUnit) {
  return LocalStorageAutoConvertUnit(initialUnit) + LocalStorageAutoConvertPrice(price, initialUnit);
}
function convertPriceOnString(pricing) {
  if (pricing.length > 0) {
    return pricing;
  }

  if (!pricing.paramsContent) {
    return pricing.content;
  }

  var cloneParams = _objectSpread({}, pricing.paramsContent);

  for (var key in cloneParams) {
    // eslint-disable-next-line no-prototype-builtins
    if (cloneParams.hasOwnProperty(key)) {
      cloneParams[key] = AutoConvertPriceWithUnit(parseInt(cloneParams[key], 10), pricing.unit);
    }
  }

  var names = Object.keys(cloneParams);
  var vals = Object.values(cloneParams); // eslint-disable-next-line no-new-func

  return (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_construct__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Function, (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(names).concat(["return `".concat(pricing.content, "`;")])).apply(void 0, (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(vals));
}

/***/ }),

/***/ 80077:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var numberFormat = function numberFormat(number) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-EN";
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Intl.NumberFormat(locale, options).format(number);
};

/* harmony default export */ __webpack_exports__["Z"] = (numberFormat);

/***/ }),

/***/ 53253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ FaSearch; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaSearch(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 49604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ FiChevronDown; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiChevronDown(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "6 9 12 15 18 9"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 19738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(49711);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./common/priceConvert.js
var priceConvert = __webpack_require__(46518);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./common/useLocalStorage.js


function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  var _useState = (0,react.useState)(initialValue),
      storedValue = _useState[0],
      setStoredValue = _useState[1]; // useEffect(() => {
  //   if (typeof window === "undefined") {
  //     setStoredValue(initialValue);
  //   }
  //   try {
  //     // Get from local storage by key
  //     const item = window.localStorage.getItem(key);
  //     if (item) {
  //       setStoredValue(JSON.parse(item));
  //     } else {
  //       const valueToStore =
  //         initialValue instanceof Function ? value(initialValue) : initialValue;
  //       if (typeof window !== "undefined") {
  //         window.localStorage.setItem(key, JSON.stringify(valueToStore));
  //       }
  //       setStoredValue(valueToStore);
  //     }
  //     // Parse stored json or if none return initialValue
  //   } catch (error) {
  //     // If error also return initialValue
  //     console.log(error);
  //     setStoredValue(initialValue);
  //   }
  // }, []);
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.


  var setValue = function setValue(value) {
    try {
      // Allow value to be a function so we have same API as useState
      var valueToStore = value instanceof Function ? value(storedValue) : value; // Save state

      setStoredValue(valueToStore); // Save to local storage

      if (true) {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };

  return [storedValue, setValue];
}

/* harmony default export */ var common_useLocalStorage = (useLocalStorage);
// EXTERNAL MODULE: ./components/common/Layout/Cookies.js + 1 modules
var Cookies = __webpack_require__(56677);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./common/data/menu/data.json
var data_namespaceObject = JSON.parse('{"dataOffshore":{"secretaries":[{"title":"Company Formation","href":"/company-formation"},{"title":"Corporate Secretary","href":"/corporate-secretary"},{"title":"Nominee Director Shareholder","href":"/nominee-director-shareholder"}],"rightServices":[{"title":"Banking Support","description":"Open corporate accounts in offshore financial centers and Asia\'s leading financial hubs","href":"/banking-support"},{"title":"Accounting, Auditing & Tax Filing","description":"Fulfill reporting requirements with outsourced accounting and auditing activities","href":"/accounting-and-auditing"},{"title":"Virtual Office","description":"Enhance your business image with a mailing address in prime locations","href":"/virtual-office"}],"resources":[{"src":"/assets/images/layout/resources1-layout.svg","title":"Articles","description":"Make informed decisions with news and insights","href":"/articles"},{"src":"/assets/images/layout/resources2-layout.svg","title":"News","description":"Catch up on the latest business news","href":"/news"},{"src":"/assets/images/layout/resources3-layout.svg","title":"Announcements","description":"Get updated information about us","href":"/announcements"},{"src":"/assets/images/layout/resources4-layout.svg","title":"guide & tool","description":"Access insightful resources on company formation and more","href":"/guide-and-tool"}]},"dataHongkong":{"services":[{"src":"/assets/images/layout/services1-layout.svg","title":"Company Incorporation","description":"Register your business with digital first-solutions and industry expertise","href":"/company-incorporation"},{"src":"/assets/images/layout/services2-layout.svg","title":"Open Bank Account","description":"We can help connect your business with local banks and other digital-based alternatives","href":"/open-bank-account"},{"src":"/assets/images/layout/services3-layout.svg","title":"Accounting, Auditing & Tax Filing","description":"Fulfill annual reporting requirements with outsourced accounting and auditing activities","href":"/accounting-and-auditing"},{"src":"/assets/images/layout/services4-layout.svg","title":"Company Secretary","description":"Integrated entity management services; we organize and manage your compliance obligations","href":"/company-secretary"},{"src":"/assets/icons/headset.svg","title":"Merchant Account Consulting","description":"Reach more customers and convert more sales with your own merchant account","href":"/merchant-account-consulting"}],"resources":[{"src":"/assets/images/layout/resources1-layout.svg","title":"Articles","description":"Make informed decisions with news and insights","href":"/articles"},{"src":"/assets/images/layout/resources2-layout.svg","title":"News","description":"Catch up on the latest business news","href":"/news"},{"src":"/assets/images/layout/resources3-layout.svg","title":"Announcements","description":"Get updated information about us","href":"/announcements"},{"src":"/assets/images/layout/resources4-layout.svg","title":"guide & tool","description":"Access insightful resources on company formation and more","href":"/guide-and-tool"}]},"dataSingapore":{"services":[{"src":"/assets/images/layout/services1-layout.svg","title":"Company Incorporation","description":"Register your business with digital first-solutions and industry expertise","href":"/company-incorporation","subLink":[{"name":"For Locals & Permanent Residents","link":"/company-incorporation-local"},{"name":"For Foreigners","link":"/company-incorporation-foreigners"}]},{"src":"/assets/images/layout/services2-layout.svg","title":"Open Bank Account","description":"We can help connect your business with local banks and other digital-based alternatives","href":"/open-bank-account"},{"src":"/assets/images/layout/services3-layout.svg","title":"Accounting, Auditing & Tax Filing","description":"Fulfill annual reporting requirements with outsourced accounting and auditing activities","href":"/accounting-and-auditing"},{"src":"/assets/images/layout/services4-layout.svg","title":"Company Secretary","description":"Integrated entity management services; we organize and manage your compliance obligations","href":"/company-secretary"},{"src":"/assets/images/layout/services5-layout.svg","title":"Immigration Service","description":"Become a certified working ex-pat in Singapore; obtain relevant work visas and permits","href":"/immigration-service"},{"src":"/assets/icons/headset.svg","title":"Merchant Account Consulting","description":"Reach more customers and convert more sales with your own merchant account","href":"/merchant-account-consulting"}],"resources":[{"src":"/assets/images/layout/resources1-layout.svg","title":"Articles","description":"Make informed decisions with news and insights","href":"/articles"},{"src":"/assets/images/layout/resources2-layout.svg","title":"News","description":"Catch up on the latest business news","href":"/news"},{"src":"/assets/images/layout/resources3-layout.svg","title":"Announcements","description":"Get updated information about us","href":"/announcements"},{"src":"/assets/images/layout/resources4-layout.svg","title":"guide & tool","description":"Access insightful resources on company formation and more","href":"/guide-and-tool"}]},"dataVietNam":{"services":[{"src":"/assets/images/layout/company_registration-layout.svg","title":"Company Registration","description":"Take the smart route towards company startup with our fast and easy digital incorporation process","href":"/company-registration"},{"src":"/assets/images/layout/services2-layout.svg","title":"Open Bank Account","description":"We can help connect your business with local banks and other digital-based alternatives","href":"/open-bank-account"},{"src":"/assets/images/layout/services3-layout.svg","title":"Accounting, Auditing & Tax Filing","description":"Fulfill annual reporting requirements with outsourced accounting and auditing activities","href":"/accounting-and-auditing"},{"src":"/assets/images/layout/virtual-layout.svg","title":"Virtual Office","description":"Enhance your business image with a mailing address in prime locations","href":"/virtual-office"},{"src":"/assets/images/layout/services5-layout.svg","title":"Immigration Service","description":"Become a certified working ex-pat in Singapore; obtain relevant work visas and permits","href":"/immigration-service"}],"resources":[{"src":"/assets/images/layout/resources1-layout.svg","title":"Articles","description":"Make informed decisions with news and insights","href":"/articles"},{"src":"/assets/images/layout/resources2-layout.svg","title":"News","description":"Catch up on the latest business news","href":"/news"}]},"dataLanguage":[{"src":"/assets/images/layout/flat-hk-layout.png","name":"Hong Kong","href":"/hk","location":"hk","width":24,"height":24},{"src":"/assets/images/layout/flat-sg-layout.png","name":"Singapore","href":"/sg","location":"sg","width":24,"height":25},{"src":"/assets/images/layout/flat-offshore-layout.png","name":"Offshore","href":"/offshore","location":"offshore","width":24,"height":24},{"src":"/assets/images/layout/flat-vn-layout.png","name":"Vietnam","href":"/vn","location":"vn","width":24,"height":24}]}');
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiChevronDown.js
var FiChevronDown = __webpack_require__(49604);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/common/Layout/Footer/Dropdow/index.js





function Dropdown(_ref) {
  var onClick = _ref.onClick,
      state = _ref.state,
      content = _ref.content,
      title = _ref.title,
      classNameTitle = _ref.classNameTitle;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-4 flex cursor-pointer items-center justify-between",
      onClick: onClick,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: classNameTitle,
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat(state ? "rotate-180" : "rotate-0 ", "   text-bbc-white transition-all duration-75 ease-linear"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
          "aria-hidden": "true"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
      show: state,
      enter: "transition-all duration-300",
      enterFrom: "transform max-h-0 opacity-0",
      enterTo: "transform max-h-[400px] opacity-100",
      leave: "transition-all duration-200 ",
      leaveFrom: "transform max-h-[400px] opacity-50",
      leaveTo: "transform max-h-0 opacity-0",
      children: content
    })]
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Footer/index.js






 // DATA



var dataOffshoreService = data_namespaceObject.dataOffshore.secretaries.concat(data_namespaceObject.dataOffshore.rightServices);
var dataFooter = {
  term_policy: [{
    title: "Terms of Service",
    href: "/terms-of-services",
    rel: "nofollow"
  }, {
    title: "Legal Agreement",
    href: "/legal-of-agreement",
    rel: "nofollow"
  }, {
    title: "Refund Policy",
    href: "/refund-policy",
    rel: "nofollow"
  }, {
    title: "Privacy Policy",
    href: "/privacy-policy",
    rel: "nofollow"
  }, {
    title: "Restricted Countries List",
    href: "/restricted-countries-list",
    rel: "nofollow"
  }, {
    title: "FATCA Policy",
    href: "/fatca-policy",
    rel: "nofollow"
  }],
  useful_links: [{
    title: "Become Our Partner",
    href: "/become-our-partner",
    rel: "nofollow"
  }, {
    title: "Payment Guideline",
    href: "/payment-guideline",
    rel: "nofollow"
  }, {
    title: "Make Payment",
    href: "/make-payment",
    rel: "nofollow"
  }, {
    title: "Order Process",
    href: "/order-process",
    rel: "nofollow"
  }, {
    title: "Whitelist Guide",
    href: "/whitelist-guide",
    rel: "nofollow"
  }]
};

var LogoBrand = function LogoBrand(_ref) {
  var subclass = _ref.subclass;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "row items-center justify-between lg:justify-start ".concat(subclass),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mr-2 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://twitter.com/bbcincorp",
            target: "_blank",
            rel: "nofollow noreferrer",
            className: "flex items-center justify-center rounded  bg-bbc-white",
            style: {
              width: "34px",
              height: "34px"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/layout/twitter-layout.svg",
              width: 16,
              height: 16,
              alt: "twitter",
              loading: "lazy"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mr-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            rel: "nofollow noreferrer",
            className: "flex items-center justify-center rounded  bg-bbc-white",
            style: {
              width: "34px",
              height: "34px"
            },
            href: "https://www.facebook.com/bbcincorp",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/layout/fb-layout.svg",
              width: 8,
              height: 16,
              alt: "facebook",
              loading: "lazy"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mr-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            rel: "nofollow noreferrer",
            className: "flex items-center justify-center rounded  bg-bbc-white",
            style: {
              width: "34px",
              height: "34px"
            },
            href: "https://www.linkedin.com/company/bbcincorp",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/layout/linkedin-layout.svg",
              width: 16,
              height: 16,
              alt: "linkedin",
              loading: "lazy"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            rel: "nofollow noreferrer",
            className: "flex items-center justify-center rounded  bg-bbc-white",
            style: {
              width: "34px",
              height: "34px"
            },
            href: "https://www.youtube.com/channel/UCm9z045jcWyhncuHoyYNbMw",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/layout/youtube-layout.svg",
              width: 16,
              height: 16,
              alt: "youtube",
              loading: "lazy"
            })
          })
        })]
      })
    })
  });
};
/** ========== */


var Footer = function Footer() {
  var _useState = (0,react.useState)(false),
      useful = _useState[0],
      setUseful = _useState[1];

  var _useState2 = (0,react.useState)(false),
      terms = _useState2[0],
      setTerms = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      ourServices = _useState3[0],
      setOurServices = _useState3[1];

  var _useContext = (0,react.useContext)(contexts/* LayoutContext */.VY),
      locationRouter = _useContext.locationRouter;

  var router = (0,next_router.useRouter)();
  var moment = new Date();

  var FilterData = function FilterData() {
    var data = null;

    if (locationRouter === "offshore") {
      data = dataOffshoreService;
      var indexPrivacyPolicy = dataFooter.term_policy.findIndex(function (item) {
        return item.href === "/privacy-policy";
      });
      dataFooter.term_policy[indexPrivacyPolicy].title = "GDPR Privacy Policy";
    } else if (locationRouter === "hk") {
      data = data_namespaceObject.dataHongkong.services;
    } else if (locationRouter === "sg") {
      data = data_namespaceObject.dataSingapore.services;
    } else if (locationRouter === "vn") {
      data = data_namespaceObject.dataVietNam.services;
    }

    return data;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    id: "footer-01",
    className: "relative z-20",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
      src: "/assets/images/layout/footer-layout.png",
      alt: "bg footer",
      width: 1920,
      height: 204,
      className: " -mb-0.5 h-full w-full object-cover object-center",
      wrapper: {
        className: "w-full"
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: " w-full bg-bbc-brand-900 pt-8",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row justify-between pb-8",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 lg:col-6 ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex justify-between pb-6",
              children: [locationRouter == "hk" ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/layout/logo_white-hk-layout.svg",
                width: 138,
                height: 39,
                alt: "logo",
                loading: "lazy"
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/layout/logo_white-layout.svg",
                width: 138,
                height: 39,
                alt: "logo",
                loading: "lazy"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoBrand, {
                subclass: "lg:hidden"
              })]
            }), locationRouter !== "hk" && locationRouter !== "sg" && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: "block pb-2 text-lg font-semibold text-bbc-white hover:text-bbc-cyan-aqua",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                href: "/about-us",
                children: "About Us"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: "pb-4 text-lg font-semibold text-bbc-white ",
              children: locationRouter === "sg" || locationRouter === "hk" ? /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                className: "hover:text-bbc-cyan-aqua",
                href: "/contact-us",
                children: "Contact Us"
              }) : "Contact Us"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: "mb-4 lg:mb-6",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "mb-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                  href: "mailto:service@bbcincorp.com",
                  rel: "nofollow",
                  className: "flex items-center text-sm   text-bbc-bombay hover:text-bbc-cyan-aqua",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "/assets/icons/email.svg",
                    width: 17,
                    height: 17,
                    className: "mr-2",
                    alt: "DMCA.com Protection Status",
                    loading: "lazy"
                  }), "service@bbcincorp.com"]
                })
              }), locationRouter !== "sg" && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "mb-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                  href: "tel:+85281928666",
                  rel: "nofollow",
                  className: "flex items-center text-sm  text-bbc-bombay hover:text-bbc-cyan-aqua",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "/assets/icons/phone.svg",
                    width: 17,
                    height: 17,
                    className: "mr-2",
                    alt: "DMCA.com Protection Status",
                    loading: "lazy"
                  }), "(+852) 8192 8666"]
                })
              }), locationRouter !== "hk" && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "mb-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                  href: "tel:+6531381666",
                  rel: "nofollow",
                  className: "flex items-center text-sm   text-bbc-bombay hover:text-bbc-cyan-aqua",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "/assets/icons/phone.svg",
                    width: 17,
                    height: 17,
                    className: "mr-2",
                    alt: "DMCA.com Protection Status",
                    loading: "lazy"
                  }), "(+65) 3138 1666"]
                })
              }), locationRouter !== "sg" && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "mb-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                  rel: "nofollow noreferrer",
                  target: "_blank",
                  className: " flex text-sm   text-bbc-bombay hover:text-bbc-cyan-aqua",
                  href: "https://goo.gl/maps/adod2kPo4Ht2GXXH9",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "mt-1",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                      src: "/assets/icons/location.svg",
                      width: 17,
                      height: 17,
                      wrapper: {
                        className: "inline-block mr-2 mt-0.5 ",
                        style: {
                          width: "17px",
                          height: "17px"
                        }
                      },
                      alt: "DMCA.com Protection Status",
                      loading: "lazy"
                    })
                  }), "Room 9, 4F, Beverley Commercial Centre, 87-105 Chatham road South, Tsim Sha Tsui, Kowloon, Hong Kong"]
                })
              }), locationRouter !== "hk" && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex  text-sm  text-bbc-bombay ",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "mt-0.5 text-sm xl:mt-0 ",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                      src: "/assets/icons/location.svg",
                      width: 17,
                      height: 17,
                      wrapper: {
                        className: "inline-block mr-2 mt-0.5 ",
                        style: {
                          width: "17px",
                          height: "17px"
                        }
                      },
                      alt: "DMCA.com Protection Status",
                      loading: "lazy"
                    })
                  }), "68 Circular road, #02-01 Singapore (049422), Singapore"]
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "col-12 block lg:hidden",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown, {
                title: "Our Services",
                classNameTitle: " text-bbc-white text-lg leading-7 font-semibold ",
                state: ourServices,
                onClick: function onClick() {
                  return setOurServices(!ourServices);
                },
                content: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  className: "mb-4",
                  children: FilterData().map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      className: "pb-2 last:pb-0",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                        href: item === null || item === void 0 ? void 0 : item.href,
                        className: "text-sm text-bbc-bombay  ",
                        children: item === null || item === void 0 ? void 0 : item.title
                      })
                    }, index);
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown, {
                title: "Useful Links",
                classNameTitle: "text-lg text-bbc-white leading-7 font-semibold ",
                state: useful,
                onClick: function onClick() {
                  return setUseful(!useful);
                },
                content: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  className: "mb-4",
                  children: dataFooter.useful_links.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      className: "pb-2 last:pb-0",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                        href: item === null || item === void 0 ? void 0 : item.href,
                        className: "text-sm text-bbc-bombay",
                        rel: item === null || item === void 0 ? void 0 : item.rel,
                        target: item === null || item === void 0 ? void 0 : item.target,
                        children: item === null || item === void 0 ? void 0 : item.title
                      })
                    }, index);
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown, {
                title: "Terms & Policy",
                classNameTitle: "text-lg text-bbc-white leading-7 font-semibold ",
                state: terms,
                onClick: function onClick() {
                  return setTerms(!terms);
                },
                content: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                  className: "mb-4",
                  children: dataFooter.term_policy.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      className: "pb-2 last:pb-0",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                        href: item === null || item === void 0 ? void 0 : item.href,
                        className: "text-sm text-bbc-bombay",
                        rel: item === null || item === void 0 ? void 0 : item.rel,
                        target: item === null || item === void 0 ? void 0 : item.target,
                        children: item === null || item === void 0 ? void 0 : item.title
                      })
                    }, index);
                  })
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "".concat(locationRouter === "sg" || locationRouter === "hk" ? "mb-8" : "", " mt-6 flex"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "mr-5 block max-h-20 lg:mr-8",
                target: "_blank",
                rel: "noopener noreferrer",
                title: "DMCA.com Protection Status",
                href: "//www.dmca.com/Protection/Status.aspx?ID=1db12910-cb8b-41ab-9646-015b91ecb2c9&refurl=".concat("https://betasgo.bbcincorp.com").concat(router.asPath === "/" ? "" : router.asPath),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/layout/dmca-layout.svg",
                  width: 160,
                  height: 80,
                  alt: "DMCA.com Protection Status",
                  loading: "lazy"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-3 gap-1 lg:gap-2 ",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/layout/visa-layout.svg",
                  width: 64,
                  height: 36,
                  alt: "visa",
                  className: "max-h-9",
                  loading: "lazy"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/layout/mastercard-layout.svg",
                  width: 64,
                  height: 36,
                  className: "max-h-9",
                  alt: "master-card",
                  loading: "lazy"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/layout/american_express-layout.svg",
                  width: 64,
                  height: 36,
                  className: "max-h-9",
                  alt: "american-express",
                  loading: "lazy"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/layout/jcb-layout.svg",
                  width: 64,
                  height: 36,
                  className: "max-h-9",
                  alt: "jcb",
                  loading: "lazy"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/layout/discover-layout.svg",
                  width: 64,
                  height: 36,
                  className: "max-h-9",
                  alt: "discover",
                  loading: "lazy"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/layout/stripe-layout.svg",
                  width: 64,
                  height: 36,
                  className: "max-h-9",
                  alt: "stripe",
                  loading: "lazy"
                })]
              })]
            }), locationRouter === "hk" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "border-t border-white pt-8 text-center  opacity-75 lg:text-left  ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " pb-4 text-sm leading-6 text-bbc-bombay",
                children: "BBCIncorp Limited, Hong Kong - Registration number: 2508698 and D-U-N-S number: 664611652."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " pb-4 text-sm leading-6 text-bbc-bombay",
                children: "Licensed to use trademark by the trademark owner - BBCincorp Pte. Ltd."
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-center text-sm text-bbc-bombay lg:text-left",
                children: [moment.getFullYear(), " \xA9 BBCIncorp Limited - Copyright All Rights Reserved"]
              })]
            }), locationRouter === "sg" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "border-t border-white pt-8 text-center   opacity-75 lg:text-left  ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " pb-4 text-sm leading-6 text-bbc-bombay",
                children: "BBCIncorp Pte. Ltd., Singapore - Registration number: 201920843M"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-center text-sm  text-bbc-bombay lg:text-left",
                children: [moment.getFullYear(), " \xA9 BBCIncorp Pte. Ltd. - Copyright All Rights Reserved"]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-3  hidden lg:block",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                className: "pb-4 text-lg font-semibold text-bbc-white",
                children: "Our Services"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "mb-6",
                children: FilterData().map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "pb-2 last:pb-0 ",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                      href: item === null || item === void 0 ? void 0 : item.href,
                      rel: item === null || item === void 0 ? void 0 : item.rel,
                      target: item === null || item === void 0 ? void 0 : item.target,
                      className: "text-sm capitalize text-bbc-bombay hover:text-bbc-cyan-aqua",
                      children: item === null || item === void 0 ? void 0 : item.title
                    })
                  }, index);
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                className: "pb-4 text-lg font-semibold text-bbc-white",
                children: "Useful Links"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                children: dataFooter.useful_links.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "pb-2 last:pb-0",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                      href: item === null || item === void 0 ? void 0 : item.href,
                      rel: item === null || item === void 0 ? void 0 : item.rel,
                      target: item === null || item === void 0 ? void 0 : item.target,
                      className: "text-sm text-bbc-bombay hover:text-bbc-cyan-aqua",
                      children: item === null || item === void 0 ? void 0 : item.title
                    })
                  }, index);
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 lg:col-3 ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-6 hidden lg:block",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                className: "pb-4 text-lg  font-semibold text-bbc-white",
                children: "Terms & Policy"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "mb-6",
                children: dataFooter.term_policy.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "pb-2 last:pb-0",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                      href: item === null || item === void 0 ? void 0 : item.href,
                      rel: item === null || item === void 0 ? void 0 : item.rel,
                      target: item === null || item === void 0 ? void 0 : item.target,
                      className: "text-sm text-bbc-bombay hover:text-bbc-cyan-aqua",
                      children: item === null || item === void 0 ? void 0 : item.title
                    })
                  }, index);
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "lg:w-fit",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoBrand, {})
              }), locationRouter === "sg" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mt-4 flex items-center justify-center lg:mt-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  id: "duns-seal"
                })
              })]
            })]
          })]
        }), locationRouter === "offshore" || locationRouter === "vn" ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "row",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12",
            children: [locationRouter === "offshore" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "border-t border-white py-8 text-center opacity-75  ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " pb-2 text-sm leading-6 text-bbc-bombay",
                children: "BBCIncorp Limited, Hong Kong - Registration number: 2508698 and D-U-N-S number: 664611652"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-center text-sm text-bbc-bombay",
                children: [moment.getFullYear(), " \xA9 BBCIncorp Limited - Copyright All Rights Reserved"]
              })]
            }), locationRouter === "vn" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "border-t border-white py-8 text-center opacity-75  ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " pb-2 text-sm leading-6 text-bbc-bombay",
                children: "BBCIncorp JSC, Vietnam - Registration number: 0317232747"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-center text-sm text-bbc-bombay",
                children: [moment.getFullYear(), " \xA9 BBCIncorp JSC - Copyright All Rights Reserved"]
              })]
            })]
          })
        }) : null]
      })
    })]
  });
};

/* harmony default export */ var Layout_Footer = (Footer);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/fa/FaChevronDown.js

function FaChevronDown(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 448 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaSearch.js
var FaSearch = __webpack_require__(53253);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaTimes.js
var FaTimes = __webpack_require__(11856);
;// CONCATENATED MODULE: ./common/hooks/useOnHeaderClickOutside.js

/**
 * Set click outside menu by customized hook for header.
 * @param {reference} refNav connect jsx navbar reference.
 * @param {reference} refMenu connect jsx menu reference.
 * @param {function} handler set the new state to close the menu.
 */

var useOnHeaderClickOutside = function useOnHeaderClickOutside(refNav, refMenu, handler) {
  (0,react.useEffect)(function () {
    var listener = function listener(event) {
      if (!refNav.current || refNav.current.contains(event.target)) {
        return;
      }

      if (!refMenu.current || refMenu.current.contains(event.target)) {
        return;
      }

      handler(null);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return function () {
      /* Clean up function. Remove event before component unmount. */
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refNav, refMenu, handler]);
};

/* harmony default export */ var hooks_useOnHeaderClickOutside = (useOnHeaderClickOutside);
;// CONCATENATED MODULE: ./common/countries.js
var LOCATION_TYPES = {
  AMERICAS: "AMERICAS",
  ASIA_PACIFIC: "ASIA_PACIFIC",
  EMEA: "EMEA"
};
var TAX_RATE_TYPES = {
  ZERO: "ZERO",
  LOW: "LOW"
};
var countries = [{
  id: 1,
  label: "Anguilla",
  value: "Anguilla",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/anguilla",
  icon: "ai",
  zeroCount: 0
}, {
  id: 2,
  label: "Bahamas",
  value: "Bahamas",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/bahamas",
  icon: "bs",
  zeroCount: 1
}, {
  id: 3,
  label: "Belize",
  value: "Belize",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.LOW,
  href: "/company-formation/belize",
  icon: "bz",
  zeroCount: -1
}, {
  id: 4,
  label: "British Virgin Islands",
  value: "British Virgin Islands",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/bvi",
  icon: "vg",
  zeroCount: 2
}, {
  id: 5,
  label: "Cayman Islands",
  value: "Cayman Islands",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/cayman-islands",
  icon: "ky",
  zeroCount: 3
}, {
  id: 6,
  label: "Delaware (the US)",
  value: "Delaware (the US)",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/delaware",
  icon: "us",
  zeroCount: 4
}, {
  id: 7,
  label: "Panama",
  value: "Panama",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/panama",
  icon: "pa",
  zeroCount: 8
}, {
  id: 8,
  label: "St. Kitts & Nevis",
  value: "St. Kitts & Nevis",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/saint-kitts-and-nevis",
  icon: "kn",
  zeroCount: 11
}, {
  id: 9,
  label: "St. Vincent & Grenadines",
  value: "St. Vincent & Grenadines",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/saint-vincent-and-grenadines",
  icon: "vc",
  zeroCount: 12
}, {
  id: 11,
  label: "Marshall Islands",
  value: "Marshall Islands",
  location: LOCATION_TYPES.ASIA_PACIFIC,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/marshall-islands",
  icon: "mh",
  zeroCount: 6
}, {
  id: 12,
  label: "Samoa",
  value: "Samoa",
  location: LOCATION_TYPES.ASIA_PACIFIC,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/samoa",
  icon: "ws",
  zeroCount: 9
}, {
  id: 15,
  label: "Cyprus",
  value: "Cyprus",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.LOW,
  href: "/company-formation/cyprus",
  icon: "cy",
  zeroCount: -1
}, {
  id: 17,
  label: "Mauritius",
  value: "Mauritius",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/mauritius",
  icon: "mu",
  zeroCount: 7
}, {
  id: 18,
  label: "Seychelles",
  value: "Seychelles",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/seychelles",
  icon: "sc",
  zeroCount: 10
}, {
  id: 19,
  label: "Ras Al Khaimah (UAE)",
  value: "Ras Al Khaimah (UAE)",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/rak",
  icon: "ae",
  zeroCount: 13
}, {
  id: 20,
  label: "United Kingdom",
  value: "United Kingdom",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.LOW,
  href: "/company-formation/united-kingdom",
  icon: "gb",
  zeroCount: -1
}];
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuDesktop/MegaMenuDesktop/MegaMenuCountries/Location/index.js






var LocationAmericas = function LocationAmericas() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      className: "mb-6 text-xl font-semibold uppercase text-bbc-brand-800",
      children: "The Americas"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      children: countries.filter(function (country) {
        return country.location === LOCATION_TYPES.AMERICAS;
      }).map(function (country, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: " mb-2 text-bbc-black last:mb-0 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
            href: country.href,
            className: "inline-block hover:text-bbc-primary",
            children: country.label
          })
        }, index);
      })
    })]
  });
};

var LocationAsiaPacific = function LocationAsiaPacific() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      className: "mb-6 text-xl font-semibold uppercase text-bbc-brand-800",
      children: "Asia Pacific"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "",
      children: countries.filter(function (country) {
        return country.location === LOCATION_TYPES.ASIA_PACIFIC;
      }).map(function (country, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: " mb-2 text-bbc-black last:mb-0 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
            href: country.href,
            className: "inline-block hover:text-bbc-primary ",
            children: country.label
          })
        }, index);
      })
    })]
  });
};

var LocationEMEA = function LocationEMEA() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      className: "mb-6 text-xl font-semibold uppercase text-bbc-brand-800",
      children: "Europe, Middle East and Africa (EMEA)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "",
      children: countries.filter(function (country) {
        return country.location === LOCATION_TYPES.EMEA;
      }).map(function (country, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: " mb-2 text-bbc-black last:mb-0 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
            href: country.href,
            className: "inline-block hover:text-bbc-primary ",
            children: country.label
          })
        }, index);
      })
    })]
  });
};

function LocationPanel() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "col-12",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocationAmericas, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocationAsiaPacific, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocationEMEA, {})
      })]
    })
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuDesktop/MegaMenuDesktop/MegaMenuCountries/TaxRate/index.js

 // ZeroTax




var ZeroTax = function ZeroTax() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "border-b border-[#B5B5C3] pb-[22px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      className: "pb-6 text-xl font-semibold uppercase text-bbc-brand-800",
      children: "Zero Tax"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "row",
      children: countries.filter(function (country) {
        return country.taxRate === TAX_RATE_TYPES.ZERO;
      }).sort(function (number1, number2) {
        return number1.zeroCount > number2.zeroCount ? 1 : -1;
      }).map(function (country, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "col-4  pb-2 text-bbc-black last:pb-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
            href: country.href,
            className: "text-nowrap hover:text-bbc-primary",
            children: country.label
          })
        }, index);
      })
    })]
  });
}; // LowTax


var LowTax = function LowTax() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "pt-6",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      className: "pb-6 text-xl font-semibold uppercase text-bbc-brand-800",
      children: "LOW TAX"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "row",
      children: countries.filter(function (country) {
        return country.taxRate === TAX_RATE_TYPES.LOW;
      }).sort(function (a, b) {
        return a.label > b.label ? 1 : -1;
      }).map(function (country, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "col-4  text-bbc-black ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
            href: country.href,
            className: "hover:text-bbc-primary",
            children: country.label
          })
        }, index);
      })
    })]
  });
}; // TaxRatePanel


function TaxRatePanel() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 ",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ZeroTax, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LowTax, {})
    })]
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuDesktop/MegaMenuDesktop/MegaMenuCountries/index.js

 // Import styles from "./Index.module.scss";





function MegaMenuCountries(_ref) {
  var className = _ref.className;

  var _useState = (0,react.useState)(0),
      currTab = _useState[0],
      setCurrTab = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "shadowMenu row mt-5  rounded bg-white py-[30px]  px-4 ".concat(className ? " ".concat(className) : ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: " col-2 ",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        className: "flex cursor-pointer items-center justify-between  border-b border-bbc-silver pb-5 ".concat(currTab === 0 ? "text-bbc-primary " : ""),
        onMouseEnter: function onMouseEnter() {
          return setCurrTab(0);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "font-medium",
          children: "Location"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
          className: " -rotate-90 font-normal ".concat(currTab === 0 ? "text-bbc-primary " : "text-bbc-silver")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        className: "flex cursor-pointer items-center justify-between  pt-5 font-medium ".concat(currTab === 1 ? " text-bbc-primary  " : ""),
        onMouseEnter: function onMouseEnter() {
          return setCurrTab(1);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "font-medium",
          children: "Tax rate"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
          className: "-rotate-90 font-normal ".concat(currTab === 1 ? "text-bbc-primary " : "text-bbc-silver")
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-1 flex justify-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-full w-[1px] bg-bbc-silver"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "row col-9 mx-0 pl-0 ".concat(currTab === 0 ? "" : "hidden"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocationPanel, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "row col-9 mx-0 pl-0 ".concat(currTab === 1 ? "" : "hidden"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TaxRatePanel, {})
    })]
  });
}
;// CONCATENATED MODULE: ./components/atoms/Icon/hi/HiOutlineChevronDoubleRight.js

function HiOutlineChevronDoubleRight(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "2",
        "d": "M13 5l7 7-7 7M5 5l7 7-7 7"
      }
    }]
  })(props);
}
;
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuComponents/MegaItem/index.js







var CardColum = function CardColum(_ref) {
  var imageSrc = _ref.imageSrc,
      title = _ref.title,
      description = _ref.description,
      href = _ref.href,
      border = _ref.border,
      subLink = _ref.subLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: " max-w-[100%] cursor-pointer overflow-x-hidden",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "group",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
        href: href,
        rel: "dofollow",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: imageSrc,
            width: 36,
            height: 36,
            alt: title,
            className: "mr-4"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: subLink ? "" : border,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                className: "inline-block pt-1 pb-1 text-lg  font-semibold uppercase tracking-[0.25px] text-bbc-brand-800  group-hover:text-bbc-primary group-hover:transition-all group-hover:duration-75 group-hover:ease-linear ",
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "hidden group-hover:block ",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(HiOutlineChevronDoubleRight, {
                  size: 16,
                  className: " ".concat(title == "Company Formation" ? "ml-1" : "ml-2", " text-bbc-primary  transition-all duration-75 ease-linear")
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-sm tracking-[0.25px]  text-bbc-neutral-800 group-hover:text-bbc-black xl:text-base",
              children: description
            })]
          })]
        })
      })
    }), subLink && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-4 ml-[50px] flex flex-col ".concat(subLink ? border : ""),
      children: subLink.map(function (el, idx) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
          href: el.link,
          className: "py-1 font-semibold text-bbc-brand-800 hover:text-bbc-primary",
          children: el.name
        }, idx);
      })
    })]
  });
};

var CardRow = function CardRow(_ref2) {
  var imageSrc = _ref2.imageSrc,
      title = _ref2.title,
      description = _ref2.description,
      href = _ref2.href;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "group cursor-pointer ",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
      href: href,
      rel: "dofollow",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: imageSrc,
        width: 36,
        height: 36,
        alt: title,
        className: "mb-3 xl:mb-4 ",
        wrapper: {
          className: "block"
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center pb-4 xl:pb-6 ",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
          className: "inline-block text-base font-semibold uppercase tracking-[0.25px] text-bbc-brand-800 group-hover:text-bbc-primary  group-hover:transition-all group-hover:duration-75 group-hover:ease-linear xl:text-xl ",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden group-hover:block",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(HiOutlineChevronDoubleRight, {
            size: 16,
            className: " ".concat(title == "Company Formation" ? "ml-1" : "ml-2", " text-bbc-primary  transition-all duration-75 ease-linear")
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-sm tracking-[0.25px]  text-bbc-neutral-800 group-hover:text-bbc-black xl:text-base",
        children: description
      })]
    })
  });
};

function MegaItem(_ref3) {
  var className = _ref3.className,
      data = _ref3.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: Array.isArray(data) && data.length > 4 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "row",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "shadowMenu col-10  m-auto  mt-5 justify-between rounded-[10px] bg-bbc-white py-[30px] ".concat(className),
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col  pt-4 first:pt-0 last:pb-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardColum, {
              imageSrc: item.src,
              title: item.title,
              description: item.description,
              href: item.href,
              border: "".concat(index == data.length - 1 ? "" : "border-b border-bbc-silver w-full pb-4 "),
              subLink: item.subLink
            })
          }, index);
        })
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "shadowMenu row  mt-5 justify-between rounded-[10px] bg-bbc-white py-[30px] ".concat(className),
      children: data && data.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col border-r border-bbc-silver last:border-0 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardRow, {
            imageSrc: item.src,
            title: item.title,
            description: item.description,
            href: item.href
          })
        }, index);
      })
    })
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuDesktop/MegaMenuDesktop/MegaMenuResources/index.js




function ResourcesTab(_ref) {
  var className = _ref.className,
      locationRouter = _ref.locationRouter;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: " ".concat(className ? " ".concat(className) : ""),
    children: [locationRouter === "offshore" && /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItem, {
      data: data_namespaceObject.dataOffshore.resources
    }), locationRouter === "hk" && /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItem, {
      data: data_namespaceObject.dataHongkong.resources
    }), locationRouter === "sg" && /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItem, {
      data: data_namespaceObject.dataSingapore.resources
    }), locationRouter === "vn" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "m-auto lg:col-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItem, {
        data: data_namespaceObject.dataVietNam.resources
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuDesktop/MegaMenuDesktop/MegaMenuServices/index.js







function MegaMenuServices(_ref) {
  var _dataMenu$dataOffshor, _dataMenu$dataOffshor2;

  var className = _ref.className,
      locationRouter = _ref.locationRouter;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: " ".concat(className ? " ".concat(className) : ""),
    children: [locationRouter === "offshore" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: " shadowMenu row mt-5 justify-between rounded-xl bg-bbc-white py-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-4 pr-20",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/layout/iconSerives_menu-layout.svg",
          width: 36,
          height: 36,
          className: "mb-4",
          alt: "Corporate Secretary"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-4 text-xl font-semibold uppercase text-bbc-brand-800 ",
            children: "Corporate Services"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6  text-bbc-neutral-800",
            children: "Set up and manage your oversea company across the globe"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: (_dataMenu$dataOffshor = data_namespaceObject.dataOffshore) === null || _dataMenu$dataOffshor === void 0 ? void 0 : _dataMenu$dataOffshor.secretaries.map(function (secretary, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "  flex items-center border-b border-bbc-silver py-4 first:pt-0 last:border-0 last:pb-0",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
                  href: secretary.href,
                  rel: "dofollow",
                  className: " group flex w-full items-center ",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: " font-medium group-hover:text-bbc-primary group-hover:transition-all group-hover:duration-75 group-hover:ease-linear",
                    children: secretary.title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(HiOutlineChevronDoubleRight, {
                    size: 16,
                    className: "ml-2 hidden text-bbc-primary transition-all  duration-75 ease-linear group-hover:block"
                  })]
                })
              }, index);
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-8 pr-11",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mb-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "/assets/images/layout/iconSerives1_menu-layout.svg",
            width: 36,
            height: 36,
            alt: "Corporate Secretary"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-4 text-xl font-semibold uppercase text-bbc-brand-800 ",
          children: "MORE"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: (_dataMenu$dataOffshor2 = data_namespaceObject.dataOffshore) === null || _dataMenu$dataOffshor2 === void 0 ? void 0 : _dataMenu$dataOffshor2.rightServices.map(function (service, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "group cursor-pointer border-b border-bbc-silver py-4 text-bbc-black first:pt-0 last:border-0 last:pb-0",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  rel: "dofollow",
                  href: service.href,
                  className: "font-medium group-hover:text-bbc-primary group-hover:transition-all group-hover:duration-75 group-hover:ease-linear",
                  children: service.title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(HiOutlineChevronDoubleRight, {
                  size: 16,
                  className: "ml-2 hidden text-bbc-primary transition-all  duration-75 ease-linear group-hover:block"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-bbc-neutral-800 group-hover:text-bbc-black",
                children: service.description
              })]
            }, index);
          })
        })]
      })]
    }), locationRouter === "hk" && /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItem, {
      data: data_namespaceObject.dataHongkong.services
    }), locationRouter === "sg" && /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItem, {
      data: data_namespaceObject.dataSingapore.services
    }), locationRouter === "vn" && /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItem, {
      data: data_namespaceObject.dataVietNam.services
    })]
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuDesktop/MegaMenuDesktop/index.js






function MegaMenuDesktop(_ref) {
  var tab = _ref.tab,
      id = _ref.id,
      forwardedRef = _ref.forwardedRef,
      locationRouter = _ref.locationRouter;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: id,
    className: tab !== null && " " || "hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: forwardedRef,
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
        show: tab === 0,
        unmount: false,
        enter: "transition-all duration-200 ease-in",
        enterFrom: "opacity-0 -translate-y-4  ",
        enterTo: "opacity-100  translate-y-0",
        leave: "transition ease-out duration-200",
        leaveFrom: "opacity-100 translate-y-10 translate-y-0",
        leaveTo: "opacity-0 -translate-y-4 ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaMenuServices, {
          locationRouter: locationRouter,
          className: tab === 0 ? "" : "  hidden"
        })
      }), locationRouter === "offshore" && /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
        unmount: false,
        show: tab === 1,
        enter: "transition-all duration-200 ease-in",
        enterFrom: "opacity-0 -translate-y-4 ",
        enterTo: "opacity-100  translate-y-0",
        leave: "transition ease-out duration-200",
        leaveFrom: "opacity-100 translate-y-10 translate-y-0",
        leaveTo: "opacity-0 -translate-y-4 ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaMenuCountries, {
          locationRouter: locationRouter,
          className: tab === 1 ? "" : " hidden "
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
        show: tab === 2,
        enter: "transition-all duration-200 ease-in",
        enterFrom: "opacity-0 -translate-y-4  ",
        enterTo: "opacity-100  translate-y-0",
        leave: "transition ease-out duration-200",
        leaveFrom: "opacity-100 translate-y-10 translate-y-0",
        leaveTo: "opacity-0 -translate-y-4 ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ResourcesTab, {
          locationRouter: locationRouter,
          className: tab === 2 ? "" : " hidden"
        })
      })]
    })
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuDesktop/index.js











var useCustomEffect = function useCustomEffect(refNav, refMenu, handler, active, navId, navPanelId) {
  var _useContext = (0,react.useContext)(contexts/* LayoutContext */.VY),
      navLight = _useContext.navLight;

  (0,react.useEffect)(function () {
    if (true) {
      var handleNavbar = function handleNavbar() {
        var currentNav = document.getElementById(navId);
        var currNavPanel = document.getElementById(navPanelId);

        if (currentNav) {
          if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
            /*
             * If (!currentNav.classList.contains("fixed")) {
             *   currentNav.classList.add("fixed");
             * }
             */
            currentNav.style.top = "".concat(38 - document.documentElement.scrollTop >= 0 ? 38 - document.documentElement.scrollTop : 37, "px");
          } else if (currentNav.classList.contains("fixed")) {
            currentNav.classList.remove("fixed");
          }

          if (document.body.scrollTop > 38 || document.documentElement.scrollTop > 38 || navLight == true) {
            currNavPanel.style.boxShadow = "0 0 15px 0 rgb(119 119 119 / 30%)";
            active(true);
          } else {
            currNavPanel.style.boxShadow = "0px 0px 0px 0px";
            active(false);
          }
        }
      };

      handleNavbar();
      window.addEventListener("scroll", handleNavbar);
      return function () {
        window.removeEventListener("scroll", handleNavbar);
      };
    }
  }, [active, navId, navLight, navPanelId]);
  hooks_useOnHeaderClickOutside(refNav, refMenu, handler);
};

function MenuDesktop(_ref) {
  var locationRouter = _ref.locationRouter,
      customMenu = _ref.customMenu;

  var _useState = (0,react.useState)(null),
      tab = _useState[0],
      setTab = _useState[1];

  var _useState2 = (0,react.useState)(false),
      tabActive = _useState2[0],
      setTabActive = _useState2[1];

  var refNav = (0,react.useRef)();
  var refMenu = (0,react.useRef)();
  useCustomEffect(refNav, refMenu, setTab, setTabActive, "default-navbar-01", "default-navbar-panel-01");

  var handleTab = function handleTab(newTab) {
    setTab(tab === newTab ? null : newTab);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
      id: "default-navbar-01",
      className: "fixed  z-50 hidden h-auto w-full text-bbc-black  lg:block",
      style: {
        top: "38px"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "default-navbar-panel-01",
        className: "flex items-center py-3 transition-all duration-150 ".concat(tab !== null || tabActive || customMenu ? " bg-white" : "", " "),
        style: {
          height: "66px"
        },
        ref: refNav,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: " row items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "lg:col-auto xl:col-2 ",
              children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "/".concat(locationRouter),
                className: "block h-9 cursor-pointer",
                style: {
                  width: locationRouter == "hk" ? "136px" : "130px"
                },
                children: locationRouter == "hk" ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  width: 136,
                  height: 37,
                  src: "assets/images/layout/logo_black-hk-layout.svg",
                  wrapper: {
                    className: "block"
                  },
                  className: "h-full w-full",
                  alt: "logo",
                  loading: "eager"
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  width: 130,
                  height: 36,
                  src: "assets/images/layout/logo_black-layout.svg",
                  wrapper: {
                    className: "block"
                  },
                  className: "h-full w-full",
                  alt: "logo",
                  loading: "eager"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:col-auto  lg:px-2  xl:col-7",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                className: " flex justify-start text-bbc-brand-900",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  className: "text-hover-transform-x flex cursor-pointer items-center justify-center text-bbc-brand-900 hover:text-bbc-primary lg:mr-4 xl:mr-10 ".concat(tab === 0 ? " hover:text-bbc-primary" : ""),
                  onClick: function onClick() {
                    return handleTab(0);
                  },
                  title: "Services",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: " mr-2 select-none font-medium ",
                    children: "Services"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "  ".concat(tab === 0 ? "rotate-180" : "rotate-0 ", "  transition-all duration-150 ease-linear"),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaChevronDown, {
                      size: 10
                    })
                  })]
                }), locationRouter === "offshore" && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  className: "text-hover-transform-x flex cursor-pointer items-center justify-center text-bbc-brand-900 hover:text-bbc-primary lg:mr-4 xl:mr-10\n                        ".concat(tab === 1 ? " hover:text-bbc-primary" : ""),
                  onClick: function onClick() {
                    return handleTab(1);
                  },
                  title: "Countries",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "  mr-2 select-none font-medium ",
                    children: "Countries"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "".concat(tab === 1 ? "rotate-180" : "rotate-0 ", " text-xs transition-all duration-150 ease-linear"),
                    children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(FaChevronDown, {
                      size: 10
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  className: "text-hover-transform-x flex cursor-pointer items-center justify-center text-bbc-brand-900 hover:text-bbc-primary lg:mr-4 xl:mr-10 ".concat(tab === 2 ? " hover:text-bbc-primary" : ""),
                  onClick: function onClick() {
                    return handleTab(2);
                  },
                  title: "Resources",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: " mr-2 select-none font-medium ",
                    children: "Resources"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "".concat(tab === 2 ? "rotate-180" : "rotate-0 ", " text-xs transition-all duration-150 ease-linear"),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaChevronDown, {
                      size: 10
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: "text-hover-transform-x md:mr-4 xl:mr-[30px] ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                    href: "/become-our-partner",
                    rel: "dofollow",
                    title: "Partner",
                    className: " inline-block select-none  font-medium text-bbc-brand-900 hover:text-bbc-primary ",
                    children: "Partner"
                  })
                }), locationRouter === "offshore" || locationRouter === "vn" ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: "text-hover-transform-x",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                    href: "/contact-us",
                    rel: "dofollow",
                    title: "Contact Us",
                    className: " text-decoration-none inline-block  select-none  font-medium text-bbc-brand-900 hover:text-bbc-primary ",
                    children: "Contact Us"
                  })
                }) : "", locationRouter === "sg" || locationRouter === "hk" ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: "text-hover-transform-x",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                    href: "/about-us",
                    className: " text-decoration-none  inline-block select-none  font-medium text-bbc-brand-900 hover:text-bbc-primary ",
                    children: "About Us"
                  })
                }) : ""]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:col-auto xl:col-3",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-end",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "/onboarding/register",
                  className: "inline-block  rounded-full  py-2 px-6 font-semibold \n                      transition-all  lg:mr-3 xl:mr-4\n                    ".concat(tabActive || tab !== null || customMenu ? " bg-bbc-primary text-white hover:bg-bbc-secondary-100 hover:text-white" : "bg-bbc-white text-bbc-primary hover:bg-bbc-brand-600 hover:text-bbc-white "),
                  children: "Set Up Now"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "".concat("https://test-dashboard.bbcincorp.com/auth/login"),
                  className: " rounded-full  border border-bbc-primary bg-transparent py-[7px] px-6 font-semibold text-bbc-primary transition-all hover:border-bbc-secondary-100  hover:bg-bbc-secondary-100 hover:text-bbc-white",
                  children: "Login"
                })]
              })
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MegaMenuDesktop, {
        locationRouter: locationRouter,
        tab: tab,
        forwardedRef: refMenu,
        id: "menu-01"
      })]
    })
  });
}
// EXTERNAL MODULE: ./common/hooks/useOnClickOutside.js
var useOnClickOutside = __webpack_require__(93615);
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuComponents/Dropdow/index.js






function Dropdow_Dropdown(_ref) {
  var onClick = _ref.onClick,
      state = _ref.state,
      content = _ref.content,
      title = _ref.title,
      classNameTitle = _ref.classNameTitle,
      paddingBottom = _ref.paddingBottom;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex cursor-pointer items-center justify-between ".concat(paddingBottom ? paddingBottom : "pb-4"),
      onClick: onClick,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: classNameTitle,
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " text-bbc-black transition-all duration-75 ease-linear ".concat(state ? " rotate-180 " : "rotate-0"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
          "aria-hidden": "true",
          size: 16
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
      show: state,
      enter: "transition-all duration-300",
      enterFrom: "transform max-h-0 opacity-0",
      enterTo: "transform max-h-[400px] opacity-100",
      leave: "transition-all duration-200 ",
      leaveFrom: "transform max-h-[400px] opacity-50",
      leaveTo: "transform max-h-0 opacity-0",
      children: content
    })]
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuMobile/MegaMenuMobile/MegaMenuCountries/Location.js



 // TheAmericasAccordion





var TheAmericasAccordion = function TheAmericasAccordion() {
  var _useState = (0,react.useState)(false),
      americasOpened = _useState[0],
      setAmericasOpened = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "The Americas",
      paddingBottom: "pb-2",
      classNameTitle: "text-bbc-brand-800 leading-bbc-26  text-sm  font-medium uppercase",
      state: americasOpened,
      onClick: function onClick() {
        return setAmericasOpened(!americasOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-3 flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "w-1/2  pr-1",
          children: countries.filter(function (country) {
            return country.location === LOCATION_TYPES.AMERICAS;
          }).slice(0, 5).map(function (country, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-2 last:m-0 ",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                className: "inline-block text-sm leading-6 text-bbc-black",
                href: country.href,
                children: country.label
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "w-1/2 pl-1 ",
          children: countries.filter(function (country) {
            return country.location === LOCATION_TYPES.AMERICAS;
          }).slice(5).map(function (country, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: " mb-2",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                className: "inline-block text-sm leading-6 text-bbc-black",
                href: country.href,
                children: country.label
              })
            }, index);
          })
        })]
      })
    })
  });
}; // AsiaPacificAccordion


var AsiaPacificAccordion = function AsiaPacificAccordion() {
  var _useState2 = (0,react.useState)(false),
      APOpened = _useState2[0],
      setAPOpened = _useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "Asia Pacific",
      paddingBottom: "pb-2",
      classNameTitle: " text-bbc-brand-800 text-sm leading-bbc-26 font-medium uppercase",
      state: APOpened,
      onClick: function onClick() {
        return setAPOpened(!APOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "mb-3 flex",
        children: countries.filter(function (country) {
          return country.location === LOCATION_TYPES.ASIA_PACIFIC;
        }).map(function (country, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: " col-6 last:pl-1",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
              className: "inline-block  text-sm leading-6",
              href: country.href,
              children: country.label
            })
          }, index);
        })
      })
    })
  });
}; // EMEAAccordion


var EMEAAccordion = function EMEAAccordion() {
  var _useState3 = (0,react.useState)(false),
      EMEAOpened = _useState3[0],
      setEMEAOpened = _useState3[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "Europe, Middle East and Africa (EMEA)",
      paddingBottom: "pb-2",
      classNameTitle: "text-bbc-brand-800 text-sm leading-bbc-26  font-medium uppercase",
      state: EMEAOpened,
      onClick: function onClick() {
        return setEMEAOpened(!EMEAOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-3 flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "w-1/2  pr-1",
          children: countries.filter(function (country) {
            return country.location === LOCATION_TYPES.EMEA;
          }).slice(0, 3).map(function (country, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-2 last:m-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                className: "inline-block text-sm leading-6",
                href: country.href,
                children: country.label
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "w-1/2 pl-1 ",
          children: countries.filter(function (country) {
            return country.location === LOCATION_TYPES.EMEA;
          }).slice(3).map(function (country, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-2 last:m-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                className: "inline-block text-sm leading-6",
                href: country.href,
                children: country.label
              })
            }, index);
          })
        })]
      })
    })
  });
}; // Location


function LocationAccordion() {
  var _useState4 = (0,react.useState)(false),
      locationOpened = _useState4[0],
      setLocationOpened = _useState4[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "Location",
      paddingBottom: "pb-2",
      classNameTitle: "inline-block  font-medium ",
      state: locationOpened,
      onClick: function onClick() {
        return setLocationOpened(!locationOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "list-unstyled m-0 pl-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TheAmericasAccordion, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AsiaPacificAccordion, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EMEAAccordion, {})
        })]
      })
    })
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuMobile/MegaMenuMobile/MegaMenuCountries/TaxRate.js








var ZeroTaxAccordion = function ZeroTaxAccordion() {
  var _useState = (0,react.useState)(false),
      zeroOpened = _useState[0],
      setZeroOpened = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "Zero tax",
      paddingBottom: "pb-2",
      classNameTitle: " text-bbc-brand-800 text-sm leading-bbc-26 font-medium uppercase",
      state: zeroOpened,
      onClick: function onClick() {
        return setZeroOpened(!zeroOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-3 flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "w-1/2  pr-1",
          children: countries.filter(function (country) {
            return country.taxRate === TAX_RATE_TYPES.ZERO;
          }).slice(0, 7).map(function (country, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-2 last:m-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                className: "inline-block text-sm leading-6",
                href: country.href,
                children: country.label
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "w-1/2 pl-1 ",
          children: countries.filter(function (country) {
            return country.taxRate === TAX_RATE_TYPES.ZERO;
          }).slice(7).map(function (country, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-2 last:m-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                className: "inline-block text-sm leading-6",
                href: country.href,
                children: country.label
              })
            }, index);
          })
        })]
      })
    })
  });
};

var LowTaxAccordion = function LowTaxAccordion() {
  var _useState2 = (0,react.useState)(false),
      lowOpened = _useState2[0],
      setLowOpened = _useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "Low tax",
      paddingBottom: "pb-2",
      classNameTitle: " text-bbc-brand-800 text-sm leading-bbc-26 font-medium uppercase",
      state: lowOpened,
      onClick: function onClick() {
        return setLowOpened(!lowOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-3 flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "w-1/2  pr-1",
          children: countries.filter(function (country) {
            return country.taxRate === TAX_RATE_TYPES.LOW;
          }).slice(0, 2).map(function (country, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-2 last:m-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                className: "inline-block text-sm leading-6",
                href: country.href,
                children: country.label
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "w-1/2 pl-1 ",
          children: countries.filter(function (country) {
            return country.taxRate === TAX_RATE_TYPES.LOW;
          }).slice(2).map(function (country, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-2 last:m-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                className: "inline-block text-sm leading-6",
                href: country.href,
                children: country.label
              })
            }, index);
          })
        })]
      })
    })
  });
};

function TaxRateAccordion() {
  var _useState3 = (0,react.useState)(false),
      taxOpened = _useState3[0],
      setTaxOpened = _useState3[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "Tax Rate",
      paddingBottom: "pb-2 ",
      classNameTitle: "inline-block  font-medium ",
      state: taxOpened,
      onClick: function onClick() {
        return setTaxOpened(!taxOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "list-unstyled mb-2 pl-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ZeroTaxAccordion, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LowTaxAccordion, {})
        })]
      })
    })
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuMobile/MegaMenuMobile/MegaMenuCountries/index.js







function MegaMenuCountries_MegaMenuCountries() {
  var _useState = (0,react.useState)(false),
      countriesOpened = _useState[0],
      setCountriesOpened = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "Countries",
      classNameTitle: "inline-block  font-medium",
      state: countriesOpened,
      onClick: function onClick() {
        return setCountriesOpened(!countriesOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "mb-2 pl-5",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LocationAccordion, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TaxRateAccordion, {})
        })]
      })
    })
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuComponents/MegaItemMobile/index.js





var Card = function Card(_ref) {
  var imageSrc = _ref.imageSrc,
      title = _ref.title,
      href = _ref.href,
      subLink = _ref.subLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center pb-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mr-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: imageSrc,
          width: 36,
          height: 36,
          alt: title,
          wrapper: {
            className: "block"
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
        href: href,
        className: "inline-block text-sm font-medium uppercase tracking-[0.25px] text-bbc-brand-800 ",
        children: title
      })]
    }), subLink && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "ml-[50px] flex flex-col",
      children: subLink.map(function (el, idx) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
          href: el.link,
          className: "mb-3 inline-block text-sm font-medium uppercase tracking-[0.25px] text-bbc-brand-800",
          children: el.name
        }, idx);
      })
    })]
  });
};

function MegaItemMobile_MegaItem(_ref2) {
  var className = _ref2.className,
      data = _ref2.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: " mb-4 ".concat(className ? " ".concat(className) : ""),
    children: data && data.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, {
          imageSrc: item.src,
          title: item.title,
          description: item.description,
          href: item.href,
          subLink: item.subLink
        })
      }, index);
    })
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuMobile/MegaMenuMobile/MegaMenuResources/index.js









function MegaMenuResources(_ref) {
  var locationRouter = _ref.locationRouter;

  var _useState = (0,react.useState)(false),
      resOpened = _useState[0],
      setResOpened = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "Resources",
      paddingBottom: "pb-4",
      classNameTitle: "inline-block  font-medium",
      state: resOpened,
      onClick: function onClick() {
        return setResOpened(!resOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [locationRouter === "offshore" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: " pb-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "mb-2 flex items-center uppercase ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/layout/resources1-layout.svg",
                width: 36,
                height: 36,
                alt: "Articles"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                href: "/articles ",
                className: "pl-1 text-sm font-medium leading-7 text-bbc-brand-800",
                children: "Articles"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "mb-2 flex items-center uppercase ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/layout/resources2-layout.svg",
                width: 36,
                height: 36,
                alt: "Articles"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                href: "/news ",
                className: "pl-1 text-sm font-medium leading-7 text-bbc-brand-800",
                children: "News"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "mb-2 flex items-center uppercase ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/layout/resources3-layout.svg",
                width: 36,
                height: 36,
                alt: "Articles"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                href: "/announcements ",
                className: "pl-1 text-sm font-medium leading-7 text-bbc-brand-800",
                children: "Announcements"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "flex  items-center uppercase ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/layout/resources4-layout.svg",
                width: 36,
                height: 36,
                alt: "Articles"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                href: "/guide-and-tool ",
                className: "pl-1 text-sm font-medium leading-7 text-bbc-brand-800",
                children: "guide and tool"
              })]
            })]
          })
        }), locationRouter === "hk" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItemMobile_MegaItem, {
            data: data_namespaceObject.dataHongkong.resources
          })
        }), locationRouter === "sg" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItemMobile_MegaItem, {
            data: data_namespaceObject.dataSingapore.resources
          })
        }), locationRouter === "vn" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItemMobile_MegaItem, {
            data: data_namespaceObject.dataVietNam.resources
          })
        })]
      })
    })
  });
}
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuMobile/MegaMenuMobile/MegaMenuServices/index.js









function MegaMenuServices_MegaMenuServices(_ref) {
  var _dataMenu$dataOffshor, _dataMenu$dataOffshor2;

  var locationRouter = _ref.locationRouter;

  var _useState = (0,react.useState)(false),
      serOpened = _useState[0],
      setSerOpened = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdow_Dropdown, {
      title: "Services",
      classNameTitle: "inline-block  font-medium",
      state: serOpened,
      onClick: function onClick() {
        return setSerOpened(!serOpened);
      },
      content: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [locationRouter === "offshore" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex items-center pb-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/layout/iconSerives_menu-layout.svg",
              width: 36,
              height: 36,
              alt: "Corporate Secretary"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "ml-1 text-sm font-medium uppercase text-bbc-brand-800",
              children: "Corporation Secretary"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: "pl-10",
            children: (_dataMenu$dataOffshor = data_namespaceObject.dataOffshore) === null || _dataMenu$dataOffshor === void 0 ? void 0 : _dataMenu$dataOffshor.secretaries.map(function (secretary, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "pb-2 text-sm leading-6 ",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  href: secretary.href,
                  children: secretary.title
                })
              }, index);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex items-center pb-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/layout/iconSerives1_menu-layout.svg",
              width: 36,
              height: 36,
              alt: "Corporate Secretary"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "ml-1 text-sm font-medium uppercase text-bbc-brand-800",
              children: "More"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: "pl-10",
            children: (_dataMenu$dataOffshor2 = data_namespaceObject.dataOffshore) === null || _dataMenu$dataOffshor2 === void 0 ? void 0 : _dataMenu$dataOffshor2.rightServices.map(function (service, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "pb-2 text-sm leading-6 first:pt-0 last:pb-4",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  href: service.href,
                  rel: "dofollow",
                  children: service.title
                })
              }, index);
            })
          })]
        }), locationRouter === "hk" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItemMobile_MegaItem, {
            data: data_namespaceObject.dataHongkong.services
          })
        }), locationRouter === "sg" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItemMobile_MegaItem, {
            data: data_namespaceObject.dataSingapore.services
          })
        }), locationRouter === "vn" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaItemMobile_MegaItem, {
            data: data_namespaceObject.dataVietNam.services
          })
        })]
      })
    })
  });
}
// EXTERNAL MODULE: ./components/common/Layout/Header/MenuMobile/Index.module.scss
var Index_module = __webpack_require__(28015);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
;// CONCATENATED MODULE: ./components/common/Layout/Header/MenuMobile/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















function MobileNavbar(_ref) {
  var _dataMenu$dataLanguag;

  var locationRouter = _ref.locationRouter;

  var _useContext = (0,react.useContext)(contexts/* LayoutContext */.VY),
      unit = _useContext.unit,
      currencyUnit = _useContext.currencyUnit,
      setCurrencyUnit = _useContext.setCurrencyUnit;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      menuOpened = _useState[0],
      setMenuOpened = _useState[1];

  var ref = (0,react.useRef)();
  (0,useOnClickOutside/* default */.Z)(ref, setMenuOpened);
  var LocationInitial = data_namespaceObject === null || data_namespaceObject === void 0 ? void 0 : (_dataMenu$dataLanguag = data_namespaceObject.dataLanguage) === null || _dataMenu$dataLanguag === void 0 ? void 0 : _dataMenu$dataLanguag.filter(function (item) {
    return item.location == locationRouter;
  });

  var _useState2 = (0,react.useState)(LocationInitial[0]),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isOpenSearchBox = _useState3[0],
      setIsOpenSearchBox = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      searchKey = _useState4[0],
      setSearchKey = _useState4[1];

  var handleSearchChange = function handleSearchChange(event) {
    if (event.key === "Enter" && event.target.value !== "") {
      setSearchKey("");
      setMenuOpened(false);
      setIsOpenSearchBox(false);
      router.push("/".concat(locationRouter, "/search?key=").concat(event.target.value));
    } else {
      setSearchKey(event.target.value);
    }
  };

  var onClickSearch = function onClickSearch() {
    setMenuOpened(false);
    setIsOpenSearchBox(false);
    router.push("/".concat(locationRouter, "/search?key=").concat(searchKey));
  };

  var renderMobileSearchBox = function renderMobileSearchBox() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat(isOpenSearchBox ? " ".concat((Index_module_default()).openSearch, "  ") : "top-0 block ", " relative flex w-full items-center justify-end transition-all duration-500 ease-in-out"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " flex items-center rounded-full border border-bbc-primary bg-bbc-white py-2 px-4 ".concat(isOpenSearchBox === true ? " w-9/12 " : "w-full", " z-20  transition-all duration-500 ease-in-out"),
        onFocus: function onFocus() {
          setIsOpenSearchBox(true);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaSearch/* FaSearch */.U, {
          size: 18,
          className: " font-semibold text-bbc-neutral-600",
          onClick: onClickSearch
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("style", {
          children: "\n            /* Remove chrome clear button */\n            input[type=\"search\"]::-webkit-search-decoration,\n            input[type=\"search\"]::-webkit-search-cancel-button,\n            input[type=\"search\"]::-webkit-search-results-button,\n            input[type=\"search\"]::-webkit-search-results-decoration {\n              -webkit-appearance: none;\n            }\n          "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          type: "search",
          placeholder: "Search",
          value: searchKey,
          className: "w-full border-none bg-transparent p-0 pl-2 font-normal placeholder-bbc-neutral-700 outline-none focus:ring-0",
          onChange: handleSearchChange,
          onKeyDown: handleSearchChange
        }), isOpenSearchBox && /*#__PURE__*/(0,jsx_runtime.jsx)(FaTimes/* FaTimes */.a, {
          size: 18,
          className: "font-semibold text-bbc-neutral-600",
          onClick: function onClick() {
            setSearchKey("");
          }
        })]
      }), isOpenSearchBox && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "".concat(isOpenSearchBox ? "w-3/12" : "w-full", " z-10 border-none  bg-transparent text-sm font-medium text-white outline-none transition-all duration-500 ease-in-out  hover:text-[#2997ff] focus:ring-0"),
        onClick: function onClick() {
          setIsOpenSearchBox(false);
        },
        children: "Cancel"
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
    className: "shadowMenu fixed top-0 left-0 z-50 block   w-full overflow-y-auto overflow-x-hidden bg-white p-0  text-bbc-black lg:hidden",
    ref: ref,
    style: {
      maxHeight: "90%"
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex  items-center justify-between  py-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
            href: "/",
            className: "block h-9  cursor-pointer",
            style: {
              width: locationRouter == "hk" ? "136px" : "130px"
            },
            children: locationRouter == "hk" ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              width: 136,
              height: 37,
              src: "assets/images/layout/logo_black-hk-layout.svg",
              className: "logo webpexpress-processed",
              alt: "logo",
              loading: "eager"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              width: 130,
              height: 36,
              src: "assets/images/layout/logo_black-layout.svg",
              className: "logo webpexpress-processed",
              alt: "logo",
              loading: "eager"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            onClick: function onClick() {
              return setMenuOpened(!menuOpened);
            },
            className: "flex h-7 cursor-pointer flex-col justify-around border-0 bg-transparent p-0 outline-none focus:outline-none",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: {
                transformOrigin: "1px"
              },
              className: "block h-0.5 w-7 rounded-sm bg-bbc-brand-800 ".concat(menuOpened ? "rotate-45 transform transition-all duration-150 ease-linear " : "")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: {
                transformOrigin: "1px"
              },
              className: "block h-0.5 w-7 rounded-sm  bg-bbc-brand-800 ".concat(menuOpened ? "translate-x-2  transform opacity-0 transition-all duration-150 ease-linear " : "")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: {
                transformOrigin: "1px"
              },
              className: "block h-0.5 w-7 rounded-sm bg-bbc-brand-800  ".concat(menuOpened ? "-rotate-45 transform transition-all duration-150 ease-linear" : "")
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
          show: menuOpened,
          enter: "transition-all duration-300 ease-linear",
          enterFrom: "transform max-h-0 ",
          enterTo: "transform max-h-[90vh] opacity-100",
          leave: "transition-all duration-200 ease-linear",
          leaveFrom: "transform max-h-[90vh]  opacity-50",
          leaveTo: "transform max-h-0 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-8 mt-3",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "row mb-4",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat(locationRouter == "sg" && ChangePriceSiteList.includes(router.asPath) ? "col-8" : "col-12"),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox */.Ri, {
                    value: selected,
                    onChange: setSelected,
                    children: function children(_ref2) {
                      var _dataMenu$dataLanguag2;

                      var open = _ref2.open;
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: " rounded-full border border-bbc-primary ",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Button */.Ri.Button, {
                          className: "w-full outline-none focus:outline-none ",
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between py-2 px-4",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "flex items-center",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                                src: (selected === null || selected === void 0 ? void 0 : selected.src) || "/assets/images/layout/flat-offshore-layout.png",
                                width: (selected === null || selected === void 0 ? void 0 : selected.width) || 24,
                                height: (selected === null || selected === void 0 ? void 0 : selected.height) || 24,
                                className: "w-full ",
                                wrapper: {
                                  className: "w-6 h-6"
                                },
                                alt: selected === null || selected === void 0 ? void 0 : selected.name
                              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                className: "ml-2 font-medium text-bbc-black",
                                children: selected === null || selected === void 0 ? void 0 : selected.name
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              className: "".concat(open ? "rotate-180" : "rotate-0 ", "   text-bbc-black transition-all duration-75 ease-linear"),
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
                                "aria-hidden": "true"
                              })
                            })]
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
                          as: react.Fragment,
                          leave: "transition ease-in duration-100",
                          leaveFrom: "opacity-100",
                          leaveTo: "opacity-0",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Options */.Ri.Options, {
                            className: "absolute z-50 mt-4 w-full rounded-2xl  bg-white p-4 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                            children: data_namespaceObject === null || data_namespaceObject === void 0 ? void 0 : (_dataMenu$dataLanguag2 = data_namespaceObject.dataLanguage) === null || _dataMenu$dataLanguag2 === void 0 ? void 0 : _dataMenu$dataLanguag2.filter(function (item) {
                              return item.location !== locationRouter;
                            }).map(function (countries, index) {
                              return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                                className: function className(_ref3) {
                                  var active = _ref3.active;
                                  return " relative cursor-default select-none border-b border-[#B5B5C3] py-3 first:pt-0 last:border-b-0 last:pb-0   ".concat(active ? "" : "");
                                },
                                value: countries,
                                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                                  href: countries.href,
                                  className: "flex cursor-pointer items-center ",
                                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                                      src: countries === null || countries === void 0 ? void 0 : countries.src,
                                      width: 24,
                                      height: 24,
                                      className: "h-full w-full",
                                      wrapper: {
                                        className: "w-6 h-6"
                                      },
                                      alt: countries === null || countries === void 0 ? void 0 : countries.name
                                    })
                                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                    className: " ml-2 text-base font-medium hover:text-bbc-primary",
                                    children: countries.name
                                  })]
                                })
                              }, index);
                            })
                          })
                        })]
                      });
                    }
                  })
                }), locationRouter == "sg" && ChangePriceSiteList.includes(router.asPath) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-4 pl-0",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox */.Ri, {
                    value: currencyUnit,
                    onChange: function onChange(value) {
                      setCurrencyUnit(function (prev) {
                        return _objectSpread({
                          previous: prev.id,
                          current: value.id
                        }, value);
                      });
                    },
                    children: function children(_ref4) {
                      var listUnitOptions = _ref4.listUnitOptions;
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: " rounded-full border border-bbc-primary ",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Button */.Ri.Button, {
                          className: "w-full outline-none focus:outline-none ",
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between py-2 px-4",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              className: "flex items-center",
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                className: "ml-2 font-medium text-bbc-black",
                                children: currencyUnit === null || currencyUnit === void 0 ? void 0 : currencyUnit.name
                              })
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              className: "".concat(listUnitOptions ? "rotate-180" : "rotate-0 ", "   text-bbc-black transition-all duration-75 ease-linear"),
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
                                "aria-hidden": "true"
                              })
                            })]
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
                          as: react.Fragment,
                          leave: "transition ease-in duration-100",
                          leaveFrom: "opacity-100",
                          leaveTo: "opacity-0",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Options */.Ri.Options, {
                            className: "absolute z-50 mt-4 w-full max-w-[110px] rounded-2xl bg-white p-4 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                            children: unit === null || unit === void 0 ? void 0 : unit.filter(function (item) {
                              return item.name !== currencyUnit.name;
                            }).map(function (el, index) {
                              return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                                className: function className(_ref5) {
                                  var active = _ref5.active;
                                  return " relative cursor-default select-none border-b border-[#B5B5C3] py-3 first:pt-0 last:border-b-0 last:pb-0   ".concat(active ? "" : "");
                                },
                                value: el,
                                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                  className: "flex cursor-pointer items-center ",
                                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                    className: " ml-2 text-base font-medium hover:text-bbc-primary",
                                    children: el.name
                                  })
                                })
                              }, index);
                            })
                          })
                        })]
                      });
                    }
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "col-12 ",
                children: [renderMobileSearchBox(), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
                  appear: true,
                  show: isOpenSearchBox,
                  as: react.Fragment,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "relative h-screen",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
                      as: react.Fragment,
                      enter: "ease-out duration-300",
                      enterFrom: "opacity-0",
                      enterTo: "opacity-100",
                      leave: "ease-in duration-300",
                      leaveFrom: "opacity-100",
                      leaveTo: "opacity-0",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 w-full bg-bbc-gray"
                      })
                    })
                  })
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaMenuServices_MegaMenuServices, {
                  locationRouter: locationRouter
                })
              }), locationRouter === "offshore" && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaMenuCountries_MegaMenuCountries, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(MegaMenuResources, {
                  locationRouter: locationRouter
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: " pb-4 font-medium",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  rel: "dofollow",
                  href: "/become-our-partner",
                  children: "Partner"
                })
              }), locationRouter === "offshore" || locationRouter === "vn" ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "pb-10 font-medium",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  className: " inline-block",
                  rel: "dofollow",
                  href: "/contact-us",
                  children: "Contact Us"
                })
              }) : "", locationRouter === "sg" || locationRouter === "hk" ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "pb-10 font-medium",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                  className: "inline-block",
                  rel: "dofollow",
                  href: "/about-us",
                  children: "About Us"
                })
              }) : "", /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    href: "/onboarding/register",
                    className: "mr-4 inline-block w-full rounded-full bg-bbc-primary py-2 text-center font-semibold text-bbc-white transition-all hover:bg-bbc-brand-600",
                    children: "Set Up Now"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mt-6 mb-6",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    href: "".concat("https://test-dashboard.bbcincorp.com/auth/login"),
                    className: "  mr-4  inline-block w-full rounded-full border border-bbc-primary bg-bbc-white py-2 text-center font-semibold   text-bbc-primary  transition-all hover:bg-bbc-brand-600  ",
                    children: "Login"
                  })
                })]
              })]
            })]
          })
        })]
      })
    })
  });
}
// EXTERNAL MODULE: ./components/common/Layout/Header/Index.module.scss
var Header_Index_module = __webpack_require__(82733);
var Header_Index_module_default = /*#__PURE__*/__webpack_require__.n(Header_Index_module);
;// CONCATENATED MODULE: ./components/common/Layout/Header/index.js



function Header_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Header_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Header_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Header_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-unknown-property */



 // Data













var ChangePriceSiteList = ["/sg/company-incorporation-local", "/sg/company-incorporation-foreigners", "/sg/accounting-and-auditing", "/sg/company-secretary", "/sg/immigration-service", "/sg/open-bank-account"];
function Header() {
  var _dataMenu$dataLanguag, _dataMenu$dataLanguag2;

  var router = (0,next_router.useRouter)();

  var _useContext = (0,react.useContext)(contexts/* LayoutContext */.VY),
      locationRouter = _useContext.locationRouter,
      unit = _useContext.unit,
      currencyUnit = _useContext.currencyUnit,
      setCurrencyUnit = _useContext.setCurrencyUnit,
      customMenu = _useContext.customMenu;

  var LocationInitial = data_namespaceObject === null || data_namespaceObject === void 0 ? void 0 : (_dataMenu$dataLanguag = data_namespaceObject.dataLanguage) === null || _dataMenu$dataLanguag === void 0 ? void 0 : _dataMenu$dataLanguag.filter(function (item) {
    return item.location == locationRouter;
  });

  var _useState = (0,react.useState)(LocationInitial[0]),
      selected = _useState[0],
      setSelected = _useState[1];

  var _useState2 = (0,react.useState)(false),
      listboxOptions = _useState2[0],
      setListboxOptions = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isOpenSearchBox = _useState3[0],
      setIsOpenSearchBox = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      searchKey = _useState4[0],
      setSearchKey = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isLoading = _useState5[0],
      setIsLoading = _useState5[1];

  var inputSearchRef = (0,react.useRef)(null);

  var _useState6 = (0,react.useState)(false),
      listUnitOptions = _useState6[0],
      setListUnitOptions = _useState6[1];

  (0,react.useEffect)(function () {
    setIsLoading(false);
    setIsOpenSearchBox(false);
  }, [router.asPath]);

  var handleSearchChange = function handleSearchChange(event) {
    setSearchKey(event.target.value); // Event.preventdefault();
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === "Enter" && event.target.value !== "") {
      setSearchKey("");
      setIsLoading(true); // Router.push(`/${locationRouter}/search?key=${event.target.value}`);

      window.location.href = "/".concat(locationRouter, "/search?key=").concat(event.target.value);
    }
  };

  var handleOnChangePriceUnit = function handleOnChangePriceUnit(value) {
    setCurrencyUnit(function (prev) {
      return Header_objectSpread({
        previous: prev.id,
        current: value.id
      }, value);
    });
  };

  var renderDesktopSearchBox = function renderDesktopSearchBox() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex w-full items-center justify-center",
        style: {
          height: "38px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
          appear: true,
          show: isOpenSearchBox,
          as: "div",
          className: "absolute w-1/2",
          style: {
            zIndex: 80
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
            as: react.Fragment,
            enter: "transition-all ease-out duration-700",
            enterFrom: "opacity-0 scale-x-0 translate-x-full",
            enterTo: "opacity-100 scale-x-100 translate-x-0",
            leave: "transition-all ease-in duration-300",
            leaveFrom: "opacity-100 scale-x-100 translate-x-0",
            leaveTo: "opacity-0 scale-x-0 translate-x-full",
            afterEnter: function afterEnter() {
              var _inputSearchRef$curre;

              // Focus vào input sau khi enter animation chạy xong
              (_inputSearchRef$curre = inputSearchRef.current) === null || _inputSearchRef$curre === void 0 ? void 0 : _inputSearchRef$curre.focus();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "jsx-2596660590" + " " + "inline-flex w-full items-center justify-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaSearch/* FaSearch */.U, {
                size: 18,
                className: "mr-2 font-semibold text-bbc-neutral-600"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(style["default"], {
                id: "2596660590",
                children: ["input[type=\"search\"].jsx-2596660590::-webkit-search-decoration,input[type=\"search\"].jsx-2596660590::-webkit-search-cancel-button,input[type=\"search\"].jsx-2596660590::-webkit-search-results-button,input[type=\"search\"].jsx-2596660590::-webkit-search-results-decoration{-webkit-appearance:none;}"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                // AutoFocus // Nếu dùng autoFocus sẽ làm mất enter animation của transition
                ref: inputSearchRef,
                type: "search",
                placeholder: "Search",
                value: searchKey,
                onChange: handleSearchChange,
                onKeyDown: handleKeyDown,
                className: "jsx-2596660590" + " " + "ml-2 w-full border-none bg-transparent text-bbc-neutral-600 placeholder-bbc-neutral-600 outline-none transition-all duration-500 ease-out focus:ring-0"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                btnDisplay: "inline-flex justify-center items-center",
                othersClass: "border-none bg-transparent hover:bg-transparent text-bbc-neutral-600 font-normal outline-none",
                onClick: function onClick() {
                  setIsOpenSearchBox(false);
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaTimes/* FaTimes */.a, {
                  size: 18,
                  className: "mr-2 font-semibold text-bbc-neutral-600"
                })
              })]
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
          show: !isOpenSearchBox,
          as: "div",
          className: "absolute w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
            as: react.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-x-0",
            enterTo: "opacity-100 scale-x-100",
            leave: "ease-in duration-300",
            leaveFrom: "opacity-100 scale-x-100",
            leaveTo: "opacity-0 scale-x-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "inline-flex w-full items-center justify-end",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
                btnDisplay: "inline-flex justify-center items-center",
                othersClass: "border-none bg-transparent hover:bg-transparent text-bbc-neutral-600 font-normal outline-none",
                onClick: function onClick() {
                  setIsOpenSearchBox(true);
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaSearch/* FaSearch */.U, {
                  size: 18,
                  className: "mr-2 font-semibold text-bbc-neutral-600"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "block w-full text-base",
                  children: "Search"
                })]
              })
            })
          })
        })]
      })
    });
  };

  (0,react.useEffect)(function () {
    if (true) {
      var header = document.getElementById("header-01");

      var handleNavbar = function handleNavbar() {
        if (header) {
          if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
            if (!header.classList.contains("fixed")) {
              header.classList.add("fixed");
              header.classList.remove("absolute");
            }
          } else {
            header.classList.add("absolute");
            header.classList.remove("fixed");
          }
        }
      };

      handleNavbar();
      window.addEventListener("scroll", handleNavbar);
      return function () {
        window.removeEventListener("scroll", handleNavbar);
      };
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      id: "header-01",
      className: "absolute top-0 left-0  z-50 w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hidden lg:block",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: " bg-bbc-gray ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "row",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "col-12 flex items-center  justify-between",
                style: {
                  height: "38px"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox */.Ri, {
                    value: selected,
                    onChange: setSelected,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "relative ",
                      onMouseEnter: function onMouseEnter() {
                        return setListboxOptions(true);
                      },
                      onMouseLeave: function onMouseLeave() {
                        return setListboxOptions(false);
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Button */.Ri.Button, {
                        as: "div",
                        role: "button",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: " flex items-center ".concat((Header_Index_module_default()).listButton, " "),
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                            src: (selected === null || selected === void 0 ? void 0 : selected.src) || "/assets/images/layout/flat-offshore-layout.png",
                            width: selected.width || 24,
                            height: selected.height || 24,
                            className: "h-full w-full",
                            wrapper: {
                              className: "w-6 h-6"
                            },
                            alt: selected === null || selected === void 0 ? void 0 : selected.name
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            className: "ml-1.5 flex-1 whitespace-nowrap text-sm font-medium leading-6 text-white",
                            children: selected.name
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: "".concat(listboxOptions ? "rotate-180" : "rotate-0 ", " ml-1.5 text-xs transition-all duration-150 ease-linear"),
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaChevronDown, {
                              className: " text-bbc-white"
                            })
                          })]
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
                        as: react.Fragment,
                        show: listboxOptions,
                        enter: "transition-all duration-300 ease-in",
                        enterFrom: "opacity-0 -translate-y-5  ",
                        enterTo: "opacity-100  translate-y-0",
                        leave: "transition ease-out duration-300",
                        leaveFrom: "opacity-100 translate-y-10 translate-y-0",
                        leaveTo: "opacity-0 -translate-y-4 ",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Options */.Ri.Options, {
                          className: "".concat((Header_Index_module_default()).listOptions),
                          children: data_namespaceObject === null || data_namespaceObject === void 0 ? void 0 : (_dataMenu$dataLanguag2 = data_namespaceObject.dataLanguage) === null || _dataMenu$dataLanguag2 === void 0 ? void 0 : _dataMenu$dataLanguag2.filter(function (item) {
                            return item.location !== locationRouter;
                          }).map(function (countries, index) {
                            return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                              className: function className(_ref) {
                                var active = _ref.active;
                                return "  ".concat((Header_Index_module_default()).listOption, "   ").concat(active ? "" : "");
                              },
                              value: countries,
                              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                                href: countries.href,
                                className: "flex w-full cursor-pointer items-center  justify-start text-bbc-black  ",
                                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                                  src: countries === null || countries === void 0 ? void 0 : countries.src,
                                  width: countries.width || 24,
                                  height: countries.height || 24,
                                  className: "w-full ",
                                  wrapper: {
                                    className: "w-6 h-6"
                                  },
                                  alt: countries === null || countries === void 0 ? void 0 : countries.name
                                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                  className: " ml-2 text-base font-medium hover:text-bbc-primary",
                                  children: countries.name
                                })]
                              })
                            }, index);
                          })
                        })
                      })]
                    })
                  })
                }), renderDesktopSearchBox(), locationRouter == "sg" && ChangePriceSiteList.includes(router.asPath) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox */.Ri, {
                    value: currencyUnit,
                    onChange: handleOnChangePriceUnit,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "relative ",
                      onMouseEnter: function onMouseEnter() {
                        return setListUnitOptions(true);
                      },
                      onMouseLeave: function onMouseLeave() {
                        return setListUnitOptions(false);
                      },
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Button */.Ri.Button, {
                        as: "div",
                        role: "button",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: " flex items-center ".concat((Header_Index_module_default()).listButton, " "),
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: "grid h-6 w-6 place-content-center rounded-full bg-bbc-yellow-500 text-[10px] font-semibold leading-6",
                            children: currencyUnit.value
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            className: "ml-1.5 flex-1 whitespace-nowrap text-sm font-medium leading-6 text-white",
                            children: currencyUnit.name
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: "".concat(listUnitOptions ? "rotate-180" : "rotate-0 ", " ml-1.5 text-xs transition-all duration-150 ease-linear"),
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaChevronDown, {
                              className: " text-bbc-white"
                            })
                          })]
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
                        as: react.Fragment,
                        show: listUnitOptions,
                        enter: "transition-all duration-300 ease-in",
                        enterFrom: "opacity-0 -translate-y-5  ",
                        enterTo: "opacity-100  translate-y-0",
                        leave: "transition ease-out duration-300",
                        leaveFrom: "opacity-100 translate-y-10 translate-y-0",
                        leaveTo: "opacity-0 -translate-y-4 ",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Options */.Ri.Options, {
                          className: "".concat((Header_Index_module_default()).listOptions),
                          children: unit === null || unit === void 0 ? void 0 : unit.filter(function (item) {
                            return item.id !== currencyUnit.id;
                          }).map(function (el, index) {
                            return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                              className: function className(_ref2) {
                                var active = _ref2.active;
                                return "flex ".concat((Header_Index_module_default()).listOption, "   ").concat(active ? "" : "");
                              },
                              value: el,
                              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "flex w-full cursor-pointer items-center  justify-start text-bbc-black",
                                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                  className: "grid h-6 w-6 place-content-center rounded-full bg-bbc-yellow-500 text-[10px] font-semibold leading-6",
                                  children: el.value
                                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                  className: "ml-1.5 flex-1 whitespace-nowrap text-sm font-medium leading-6 ",
                                  children: el.name
                                })]
                              })
                            }, index);
                          })
                        })
                      })]
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
                  show: isOpenSearchBox,
                  as: react.Fragment,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "relative h-screen",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
                      as: react.Fragment,
                      enter: "ease-out duration-300",
                      enterFrom: "opacity-0",
                      enterTo: "opacity-100",
                      leave: "ease-in duration-300",
                      leaveFrom: "opacity-100",
                      leaveTo: "opacity-0",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 top-0 w-full ".concat((Header_Index_module_default()).searchButton, " "),
                        onClick: function onClick() {
                          setSearchKey("");
                          setIsOpenSearchBox(false);
                        },
                        children: isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          id: "search-header",
                          className: "absolute inset-0 inline-flex items-center justify-center text-bbc-white",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block h-[100px] w-[100px] animate-spin rounded-full border-[12px] border-bbc-white border-b-bbc-brand-500"
                          })
                        })
                      })
                    })
                  })
                })]
              })
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuDesktop, {
        locationRouter: locationRouter,
        customMenu: customMenu
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileNavbar, {
        locationRouter: locationRouter
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
;// CONCATENATED MODULE: ./components/common/Seo/index.js


function Seo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Seo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Seo_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Seo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








// Components

/** ========== */
var Seo = function Seo(_ref) {
  var page = _ref.page,
      locationRouter = _ref.locationRouter;
  var router = (0,next_router.useRouter)();
  var pageParseArr = JSON.parse(page);

  var getWordpressLink = function getWordpressLink(locationRouter) {
    var link = "";

    switch (locationRouter) {
      case "hk":
        link = "https://hk.headless.bbcincorp.com";
        break;

      case "offshore":
        link = "https://headless.bbcincorp.com";
        break;

      case "sg":
        link = "https://sg.headless.bbcincorp.com";
        break;

      case "vn":
        link = "https://vn.headless.bbcincorp.com";
        break;

      default:
        link = "https://hk.headless.bbcincorp.com";
        break;
    }

    return link;
  };

  var getFolder = function getFolder() {
    var _router$asPath;

    var link = (_router$asPath = router.asPath) === null || _router$asPath === void 0 ? void 0 : _router$asPath.split("/");

    if (link[1] === "hk" || link[1] === "offshore" || link[1] === "sg" || link[1] === "vn") {
      return "/".concat(link[1]);
    }

    return "";
  };

  var headLink = function headLink() {
    var lastUrl = router.asPath.substring(router.asPath.lastIndexOf("/") + 1);

    if (lastUrl === "contact-us" || lastUrl === "about-us") {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "alternate",
      href: "".concat("https://betasgo.bbcincorp.com").concat(router.asPath),
      hrefLang: "en"
    });
  };

  var getCustomHead = function getCustomHead(_ref2) {
    var arr = _ref2.arr,
        isPublicSEO = _ref2.isPublicSEO;

    if (arr && arr.length > 0) {
      var cloneArr = arr;

      if (!isPublicSEO) {
        cloneArr = cloneArr.filter(function (item) {
          return item.props.name != "robots";
        });
      }

      var cloneArrToCustomString = JSON.stringify(cloneArr).split(getWordpressLink(locationRouter)).join("https://betasgo.bbcincorp.com" + getFolder()).replace(/\n|\t/g, "");
      return {
        head: JSON.parse(cloneArrToCustomString)
      };
    }

    return {};
  };

  var dataSeo = getCustomHead({
    arr: pageParseArr,
    isPublicSEO: "" == "true"
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(head["default"], {
    children:  false ? /*#__PURE__*/0 : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [(dataSeo === null || dataSeo === void 0 ? void 0 : dataSeo.head) && dataSeo.head.map(function (item, index) {
        return /*#__PURE__*/(0,react.createElement)(item === null || item === void 0 ? void 0 : item.type, Seo_objectSpread(Seo_objectSpread({}, item === null || item === void 0 ? void 0 : item.props), {}, {
          key: index + 10
        }));
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "robots",
        content: "noindex, nofollow"
      })]
    })
  });
};

/* harmony default export */ var common_Seo = (Seo);
Seo.defaultProps = {
  page: {}
};
/** ========== */
;// CONCATENATED MODULE: ./components/common/Layout/index.js

// Vendor
// Components







/** ========== */




var Layout = function Layout(_ref) {
  var children = _ref.children,
      page = _ref.page,
      locationRouter = _ref.locationRouter,
      background = _ref.background,
      isStaticSeo = _ref.isStaticSeo,
      customMenu = _ref.customMenu;
  var unit = priceConvert/* EXCHANGE */.dK;

  var _useLocalStorage = common_useLocalStorage("price_unit", unit[0]),
      _useLocalStorage2 = (0,slicedToArray/* default */.Z)(_useLocalStorage, 2),
      currencyUnit = _useLocalStorage2[0],
      setCurrencyUnit = _useLocalStorage2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(contexts/* LayoutContext.Provider */.VY.Provider, {
    value: {
      locationRouter: locationRouter,
      currencyUnit: currencyUnit,
      unit: unit,
      setCurrencyUnit: setCurrencyUnit,
      customMenu: customMenu
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat(background ? background : "bg-bbc-main"),
      children: [!isStaticSeo && /*#__PURE__*/(0,jsx_runtime.jsx)(common_Seo, {
        page: page || "[]",
        locationRouter: locationRouter
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Layout_Footer, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Cookies/* default */.Z, {})]
  });
};

Layout.defaultProps = {
  isStaticSeo: false
};
/* harmony default export */ var common_Layout = (Layout);
/** ========== */

/***/ }),

/***/ 82733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listOptions":"Index_listOptions__I1gdg","listOption":"Index_listOption__uvijX","listButton":"Index_listButton__jRuNV","searchButton":"Index_searchButton__3bwv1"};

/***/ }),

/***/ 28015:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"openSearch":"Index_openSearch__mDZT8"};

/***/ })

}]);